module.exports = __webpack_public_path__ + "img/home.81c1606a.svg";